/* eslint-disable */
import ggModal from 'ggApp/modules/modal';

import React, { Component, } from 'react';
import { connect, } from 'react-redux';
import { bindActionCreators, } from 'redux';

@connect(
  null,
  dispatch => ({
    modalActions: bindActionCreators(ggModal.actions, dispatch),
  })
)
export default class ModalLink_Connect extends Component {

  static defaultProps = {
    modalActions: () => {},
    to: {},
    state: {},
  }

  render() {
    const
      { modalActions, to, className, children, state, } = this.props;

    return (
      <div
        className={className}
        onClick={() => modalActions.open(to, state)}>
        {children}
      </div>
    )
  }
}
